// Func = limiting Scope for this file
var lastScrollTop = 0;
(function() {

    //is explorer
    function msieversion() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            const image_fit = document.getElementsByTagName('figure');
            for (let i = 0; i < image_fit.length; i++) {
                const this_image = image_fit[i].getElementsByTagName('img')[0];
                const image_data = this_image.dataset.srcset;
                const image_src = this_image.getAttribute('src');
                image_fit[i].classList.add('ie-bg');
                if (image_data) {
                    image_fit[i].style.backgroundImage = 'url("' + image_data + '")';
                } else {
                    image_fit[i].style.backgroundImage = 'url("' + image_src + '")';
                }
            }
        } else {
            //console.log('other browser');
        }
        return false;
    }

    msieversion();

    $(document).ready(function() {

        /*To accordtion o collapsable */

        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].onclick = function() {
                this.classList.toggle("active");
                var panel = this.nextElementSibling.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        }

        //Open Navigation
        $('#menu-btn').click(function(event) {
            $('html').addClass('hide-overflow');
            $('.navigation').addClass('open');
            $('.navigation').stop().animate({ left: '0px' }, { duration: 300 });
            if ($('.navigation ul li a').hasClass('.item-open')) {
                $(".item-open").get(0).scrollIntoView(false);
            }
        });

        $('.close-menu').click(function(event) {
            event.preventDefault();
            $('html').removeClass('hide-overflow');
            $('.navigation').removeClass('open');
            $('.navigation').stop().animate({ left: '110%' }, { queue: false, duration: 300 });
        });

        if (screen.width <= 600) {
            $('a.more-btn').hide();
            $('a.more-btn').parent().addClass('more-sub');
        }

        //Call function with browser is resized.
        $(window).resize(function(event) {
            resizeWindow();
        });
        resizeWindow();

        //Acts when scroll down page.
        //$(window).scroll(function (event) {
        //scrollDown();
        //});

        // Main Nav Dropdown
        $("#primary-nav li").hover(function() {
            $(this).addClass("hover");
            $(this).children("ul.submenu").parent().addClass("hover-more");
        }, function() {
            $(this).removeClass("hover");
            $(this).children("ul.submenu").parent().removeClass("hover-more");
        });

        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];

        function calendarRange(date) {
            let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        $('.open-booking-widget-inline-date').on('click', function(e) {
            $("#adults").val(1);
            $("#child").val(0);
            $("#number_guest").text("1 ADULT");
        });

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
        $("#CheckIn").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
            }
        });
        $("#CheckOut").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });

        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

        //landing page book by and promo code text 
        let inputDate = $('#customDate').val();

        $('#countDown').countdown(inputDate, function(event) {
            var $this = $(this).html(event.strftime('' +
                '<div id="countdown_dashboard">' +
                '<div class="dash days_dash">' +
                '<div class="ctnDigits">' +
                '<div class="digit ddays1">%D</div>' +
                '<div class="digitTxt">Days</div>' +
                '</div>' +
                '</div>' +
                '<div class="dash hours_dash">' +
                '<div class="ctnDigits">' +
                '<div class="digit dhours1">%H</div>' +
                '<div class="digitTxt">Hrs</div>' +
                '</div>' +
                '</div>' +
                '<div class="dash minutes_dash">' +
                '<div class="ctnDigits">' +
                '<div class="digit dminutes1">%M</div>' +
                '<div class="digitTxt">Mins</div>' +
                '</div>' +
                '</div>' +
                '<div class="dash seconds_dash last">' +
                '<div class="ctnDigits ctnSeconds">' +
                '<div class="digit dseconds1">%S</div>' +
                '<div class="digitTxt">Secs</div>' +
                '</div>' +
                '</div>' +
                '</div>'
            ));
        });


        // BOOKING DEFAULT 2 ADULTS
        $('.open-booking-widget-inline-date').click(function(){
            $("#adults").val(2);
            $("#child").val(0);
            $("#number_guest").text("2 ADULTS");
        });


    });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

        // scrollDownAction(20, 'scroll');

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
        })
    };

}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow() {}